/* Station sign-in.
 *
 * Shared because it has to be reachable two ways: from the appointments pane,
 * which is where the front desk hits it, and from Settings → Board & day, which
 * is the only route left when the scheduling plugin is switched off and there is
 * no pane at all.
 *
 * Every tt_* table is authenticated-only, so this is not an appointments
 * feature — signed out, the board can read nothing and save nothing. */
import * as Vue from 'vue';
import { store } from '../store.js';

export const StationSignIn = {
  name: 'StationSignIn',
  props: {
    // The pane explains why in its own words; Settings does not need to.
    why: { type: String, default: '' }
  },
  setup: function () {
    var email = Vue.ref('');
    var password = Vue.ref('');

    async function submit() {
      var ok = await store.signIn(email.value.trim(), password.value);
      if (ok) password.value = '';
    }

    return { email: email, password: password, submit: submit, auth: store.auth };
  },
  template: [
    '<form class="appt-login" @submit.prevent="submit">',
    '  <p v-if="why" class="appt-login__why">{{ why }}</p>',
    /* Labels above the boxes rather than placeholders inside them: a
       placeholder is gone the moment somebody types, and it is the only name a
       screen reader had for either field. */
    '  <label class="field appt-login__field">',
    '    <span class="field__label">Station email</span>',
    '    <input v-model="email" type="email" class="input" autocomplete="username" required />',
    '  </label>',
    '  <label class="field appt-login__field">',
    '    <span class="field__label">Password</span>',
    '    <input v-model="password" type="password" class="input" autocomplete="current-password" required />',
    '  </label>',
    '  <button type="submit" class="btn btn--primary" :disabled="auth.busy">',
    '    {{ auth.busy ? "Signing in…" : "Sign in" }}</button>',
    '  <p v-if="auth.error" class="warn-line">{{ auth.error }}</p>',
    '</form>'
  ].join('\n')
};
